<template>
    <div class="border border-solid d-theme-border-grey-light bg-white px-8 py-4">
        <div class="text-center text-xl mt-2 mb-4">
            <b><vs-icon icon="arrow_back_ios" @click="previous"></vs-icon></b>
            <b class="pl-4">{{ startDate }}</b> - <b class="pr-4">{{ endDate }}</b>
            <b><vs-icon icon="arrow_forward_ios" @click="next"></vs-icon></b>
            <span class="float-right">€ {{ cost.toFixed(2) }}</span>
        </div>
        <div class="border border-solid border-grey-light">
            <div class="flex" style="border-bottom: solid 1px darkgrey;">
                <div class="flex-1 px-4 py-2"><b>{{ area.name }}</b></div>
                <div class="flex-1 px-4 py-2"><b>Maandag</b></div>
                <div class="flex-1 px-4 py-2"><b>Dinsdag</b></div>
                <div class="flex-1 px-4 py-2"><b>Woensdag</b></div>
                <div class="flex-1 px-4 py-2"><b>Donderdag</b></div>
                <div class="flex-1 px-4 py-2"><b>Vrijdag</b></div>
                <div class="flex-1 px-4 py-2"><b>Zaterdag</b></div>
                <div class="flex-1 px-4 py-2"><b>Zondag</b></div>
            </div>
            <div class="flex" v-for="data in filteredData" :key="data._id">
                <div class="flex-1 px-4 py-2" style="border-right: solid 1px darkgrey;"><b>{{ data.deliverer.insertion !== null ? data.deliverer.firstname + ' ' + data.deliverer.insertion + ' ' + data.deliverer.lastname : data.deliverer.firstname + ' ' + data.deliverer.lastname }}</b></div>
                <div class="flex-1 px-4 py-2">{{ data.monday !== null ? data.monday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.tuesday !== null ? data.tuesday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.wednesday !== null ? data.wednesday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.thursday !== null ? data.thursday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.friday !== null ? data.friday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.saturday !== null ? data.saturday.replace('|', ' : ') : '-' }}</div>
                <div class="flex-1 px-4 py-2">{{ data.sunday !== null ? data.sunday.replace('|', ' : ') : '-' }}</div>
            </div>
        </div>
        <div @click="openPopup">
            <fab
                position="bottom-right"
                bg-color="#00420D"
            ></fab>
        </div>
        <vs-popup title="Voeg medewerker toe aan rooster" :active.sync="popup">
            <div class="w-full">
                <h6>Medewerker</h6>
                <v-select label="name" :options="filteredDeliverers" :value="deliverer" v-model="deliverer" />
                <br>
                <div v-for="(day, i) in weekdays" :key="day">
                    <h6>Tijdslot ({{ day }})</h6>
                    <v-select :options="timeSlots" :value="timeSlot[i]" v-model="timeSlot[i]" />
                    <br>
                </div>
            </div>
            <br>
            <vs-button @click="savePopup">Opslaan</vs-button>
        </vs-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            area: null,
            data: [],
            startDateWeekday: 1,
            endDateWeekday: 7,
            office: 0,
            popup: false,
            deliverers: [],
            deliverer: null,
            weekdays: [
                'Maandag',
                'Dinsdag',
                'Woensdag',
                'Donderdag',
                'Vrijdag',
                'Zaterdag',
                'Zondag'
            ],
            weekday: 'Maandag',
            timeSlots: [
                'Niet werken',
                '12:00-16:00',
                '15:00-22:00',
                '15:30-22:00'
            ],
            timeSlot: [
                'Niet werken',
                'Niet werken',
                'Niet werken',
                'Niet werken',
                'Niet werken',
                'Niet werken',
                'Niet werken'
            ]
        }
    },
    created() {
        this.area = JSON.parse(localStorage.getItem('staff-area-selected'))
    },
    mounted() {
        this.getSchedule();
        this.getDeliverers();
        this.$events.listen("staff-area-selected", (event) => {
            if (this.area === event) {
                console.log("prevented");
                return;
            }
            this.area = event;
            this.getSchedule()
        });
    },
    computed: {
        cost: function() {
            var cost = 0;
            this.filteredData.map(data => {
                console.log(data);
                if(data.monday !== null) {
                    var end = data.monday.split('|')[1].split(':')
                    var start = data.monday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.tuesday !== null) {
                    var end = data.tuesday.split('|')[1].split(':')
                    var start = data.tuesday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.wednesday !== null) {
                    var end = data.wednesday.split('|')[1].split(':')
                    var start = data.wednesday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.thursday !== null) {
                    var end = data.thursday.split('|')[1].split(':')
                    var start = data.thursday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.friday !== null) {
                    var end = data.friday.split('|')[1].split(':')
                    var start = data.friday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.saturday !== null) {
                    var end = data.saturday.split('|')[1].split(':')
                    var start = data.saturday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
                if(data.sunday !== null) {
                    var end = data.sunday.split('|')[1].split(':')
                    var start = data.sunday.split('|')[0].split(':')
                    var salary = Number(data.deliverer.salary);
                    var time = (end[0] - start[0]) + (start[1]/60)
                    cost = cost + (salary * time);
                }
            });
            return cost;
        },
        startDate: function() {
            return this.$moment().isoWeekday(this.startDateWeekday).format('YYYY-MM-DD');
        },
        endDate: function() {
            return this.$moment().isoWeekday(this.endDateWeekday).format('YYYY-MM-DD');
        },
        startDateMoment: function() {
            return this.$moment().isoWeekday(this.startDateWeekday);
        },
        endDateMoment: function() {
            return this.$moment().isoWeekday(this.endDateWeekday);
        },
        filteredData: function() {
            return this.data.filter((item) => {
                if(item.deliverer.area == this.area.name && item.deliverer.office == 1) {
                    return item;
                }
            })
        },
        filteredDeliverers: function() {
            return this.deliverers.filter((item, index) => {
                if(item.area == this.area.name && item.office == 1 && item.deleted_at == null) {
                    return item;
                }
            })
        },
        selectedDate: function() {
            let date = this.$moment().isoWeekday(this.startDateWeekday);

            switch (this.weekday) {
                case 'Maandag':
                    date = date
                    break;
                case 'Dinsdag':
                    date = date.add(1, 'day')
                    break;
                case 'Woensdag':
                    date = date.add(2, 'day')
                    break;
                case 'Donderdag':
                    date = date.add(3, 'day')
                    break;
                case 'Vrijdag':
                    date = date.add(4, 'day')
                    break;
                case 'Zaterdag':
                    date = date.add(5, 'day')
                    break;
                case 'Zondag':
                    date = date.add(6, 'day')
                    break;
            }

            return date.format('YYYY-MM-DD');
        }
    },
    methods: {
        getSchedule: function() {
            this.$http.get('https://api.staging.hebtrek.nl/staff/deliverer/schedule/week', {
                headers: {
                    Authorization: "Bearer " + this.$auth.token
                },
                params: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    area: this.area.name
                }
            }).then(response => {
                this.data = response.data;
            }).catch(error => {
                this.$util.logError(error, this.$vs);
            })
        },
        getDeliverers: function() {
            this.$http.get('https://staffapi.staging.hebtrek.nl/v1/deliverers', {
                headers: {
                    Authorization: "Bearer " + this.$auth.token
                },
            }).then(response => {
                this.deliverers = response.data;
                this.deliverer = response.data[0];
            }).catch(error => {
                this.$util.logError(error, this.$vs);
            })
        },
        previous: function() {
            this.startDateWeekday = this.startDateWeekday - 7;
            this.endDateWeekday = this.endDateWeekday - 7;
            this.getSchedule();
        },
        next: function() {
            this.startDateWeekday = this.startDateWeekday + 7;
            this.endDateWeekday = this.endDateWeekday + 7;
            this.getSchedule();
        },
        getItem: function(date, time, index) {
            var deliverer = '-';
            var items = [];

            this.filteredData.map(data => {
                if(data.day == date && data.start_time == time) {
                    items.push(data)
                }
            });
            if(items[index-1] !== undefined) {
                if(items[index-1]['deliverer'].insertion !== null) {
                    deliverer = items[index-1]['deliverer'].firstname + ' ' + items[index-1]['deliverer'].insertion + ' ' + items[index-1]['deliverer'].lastname
                } else {
                    deliverer = items[index-1]['deliverer'].firstname + ' ' + items[index-1]['deliverer'].lastname
                }
            }
            return deliverer;
        },
        openPopup: function() {
            if(this.popup == true) {
                this.popup = false;
            } else {
                this.popup = true;
            }
        },
        savePopup: function() {
            var data = {
                delivererId: this.deliverer._id,
                date: this.$moment().isoWeekday(this.startDateWeekday),
                monday: this.timeSlot[0] == "Niet werken" ? "" : this.timeSlot[0].replace("-", "|"),
                tuesday: this.timeSlot[1] == "Niet werken" ? "" : this.timeSlot[1].replace("-", "|"),
                wednesday: this.timeSlot[2] == "Niet werken" ? "" : this.timeSlot[2].replace("-", "|"),
                thursday: this.timeSlot[3] == "Niet werken" ? "" : this.timeSlot[3].replace("-", "|"),
                friday: this.timeSlot[4] == "Niet werken" ? "" : this.timeSlot[4].replace("-", "|"),
                saturday: this.timeSlot[5] == "Niet werken" ? "" : this.timeSlot[5].replace("-", "|"),
                sunday: this.timeSlot[6] == "Niet werken" ? "" : this.timeSlot[6].replace("-", "|"),
            };
            this.$http.post('https://api.staging.hebtrek.nl/staff/deliverer/schedule/create', data,{
                headers: {
                    Authorization: "Bearer " + this.$auth.token
                },
            }).then(response => {
                this.getSchedule();
                this.popup = false;
            }).catch(error => {
                console.log(error)
                console.log(error.data)
            })
        }
    },
    watch: {
        filteredDeliverers: function() {
            this.deliverer = this.filteredDeliverers[0];
        }
    }
}
</script>

<style>

</style>
